import { getSymbolIconUrl } from "@cronika/assets/symbols";
import { AssetType } from "@cronika/proto/common/trading_pb";
import { useMemo } from "react";

const assetTypeToString = (type: AssetType): "crypto" | "forex" | undefined => {
  if (type === AssetType.CRYPTO) return "crypto";
  if (type === AssetType.FOREX) return "forex";
  // STOCK, INDEX, COMMODITY reuse forex-style icons (base/quote directory layout)
  if (type === AssetType.STOCK || type === AssetType.INDEX || type === AssetType.COMMODITY) return "forex";
  return undefined;
};

export function useSymbolIcon(
  type: AssetType | undefined,
  baseAsset: string | undefined,
  quoteAsset?: string,
): string | undefined {
  return useMemo(() => {
    const strType = type != null ? assetTypeToString(type) : undefined;
    if (!strType || !baseAsset) return undefined;
    return getSymbolIconUrl(strType, baseAsset, quoteAsset);
  }, [type, baseAsset, quoteAsset]);
}
